import { DomainGroup, domainGroupEnum } from "@shared/utils/domain-group";
import { useDomainGroup } from "@shared/hooks/useDomainGroup";

type LoginDomainConfig = {
  heading: string;
  // null means this domain has no MLS/brokerage affiliation concept at all.
  membershipAffiliationLabel: string | null;
  startsOnMembershipAffiliation: boolean;
};

const LOGIN_DOMAIN_CONFIG: Record<DomainGroup, LoginDomainConfig> = {
  [domainGroupEnum.SIDEKICK]: {
    heading: "Choose how you access Sidekick.",
    membershipAffiliationLabel: "MLS or brokerage account",
    startsOnMembershipAffiliation: true,
  },
  [domainGroupEnum.RADAR]: {
    heading: "Sign in to continue",
    membershipAffiliationLabel: null,
    startsOnMembershipAffiliation: false,
  },
};

export const useLoginDomainConfig = (): LoginDomainConfig =>
  LOGIN_DOMAIN_CONFIG[useDomainGroup()];
